import { Button } from "@/components/ui/button.tsx";
import { Input } from "@/components/ui/input.tsx";
import React, { useState } from "react";
import { updatePassword } from "@/api/user_api.ts";

const ChangePasswordForm: React.FC = (props) => {
	const [password, setPassword] = useState("");
	const [password2, setPassword2] = useState("");
	const [success, setSuccess] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleSubmit = (e: React.SyntheticEvent) => {
		e.preventDefault();

		setLoading(true);
		setSuccess(false);

		updatePassword(password, password2)
			.then((r) => {
				setSuccess(true);
			})
			.catch((e) => {
				//todo error handling
				console.error(e);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<form onSubmit={handleSubmit} target={"#"}>
			<div className={"flex flex-col gap-4 py-2"}>
				<label>
					Change Password
					<Input
						value={password}
						type={"password"}
						onChange={(e) => setPassword(e.target.value)}
					/>
				</label>
				<label>
					Repeat Password
					<Input
						value={password2}
						type={"password"}
						onChange={(e) => setPassword2(e.target.value)}
					/>
				</label>
				<div>
					<Button
						type="submit"
						onClick={handleSubmit}
						disabled={loading}
					>
						Save
					</Button>
					{success && (
						<div className={"text-green-400"}>
							Password Saved
						</div>
					)}
				</div>
			</div>
		</form>
	);
};

export { ChangePasswordForm };
